const formats = [
  {
    size: 'До 20',
    best: 'Бизнес-игра',
    alt: 'Фасилитация',
    note: 'Интенсивный формат, все участники вовлечены напрямую',
  },
  {
    size: '20–50',
    best: 'Тимбилдинг + бизнес-игра',
    alt: 'Командный проект',
    note: 'Комбинация для сплочения и решения рабочих задач',
  },
  {
    size: '50–100',
    best: 'Стратегическая сессия',
    alt: 'Модульная программа',
    note: 'Фасилитация для выравнивания целей и культуры',
  },
  {
    size: '100–300',
    best: 'Обучение руководителей',
    alt: 'Фасилитация отделов',
    note: 'Каскадное развитие через лидеров подразделений',
  },
  {
    size: '300+',
    best: 'Программа трансформации',
    alt: 'Корпоративная культура',
    note: 'Комплексная программа с несколькими модулями',
  },
];

export default function FormatsBySize() {
  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Какие форматы подходят именно вашей компании
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Нет универсального формата. Для каждого размера компании и задачи подбирается оптимальный подход.
        </p>

        <div className="overflow-x-auto">
          <table className="w-full min-w-[700px] bg-white rounded-2xl border border-gray-200 overflow-hidden">
            <thead>
              <tr className="bg-gray-900">
                <th className="text-left px-6 py-4 text-white font-bold">Количество сотрудников</th>
                <th className="text-left px-6 py-4 text-white font-bold">Что лучше</th>
                <th className="text-left px-6 py-4 text-white font-bold">Альтернатива</th>
                <th className="text-left px-6 py-4 text-white font-bold">Почему</th>
              </tr>
            </thead>
            <tbody>
              {formats.map((f, i) => (
                <tr key={i} className="border-t border-gray-100 hover:bg-gray-50 transition-colors">
                  <td className="px-6 py-4 font-bold text-gray-900">{f.size}</td>
                  <td className="px-6 py-4">
                    <span className="inline-block bg-teal-100 text-teal-800 px-3 py-1 rounded-full text-sm font-semibold">
                      {f.best}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-gray-700">{f.alt}</td>
                  <td className="px-6 py-4 text-gray-600 text-sm">{f.note}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="text-center text-gray-500 text-sm mt-6">
          Точный формат определяется после диагностики под задачи и специфику вашей компании.
        </p>
      </div>
    </section>
  );
}